import { useEffect, useState } from 'react'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import ProtectionInfoCard from './components/ProtectionInfo/ProtectionfoCard'
import ProtectionsInfoOptional from './components/ProtectionInfoOptional/ProtectionsInfoOptional'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import protectionsApi from 'screens/Protection/protection.api'
import { useParams } from 'react-router-dom'
import { IGrade, ITeamResult } from 'screens/Protection/protection.types'

const ProtectionTeamPage = () => {
  const [teamResult, setTeamResult] = useState<ITeamResult>(null)
  const params = useParams()

  const { wait } = useHttpLoader()

  useEffect(() => {
    if (!params?.teamId || !params?.id) return

    wait(protectionsApi.getTeamResult(Number(params?.teamId), params?.id), (resp) => {
      if (resp.status === 'success') {
        setTeamResult(resp.body)
      }
    })
  }, [params?.teamId, params?.id])

  const handleDeleteReview = (id: IGrade['id']) => {
    wait(protectionsApi.deleteReview(id), (resp) => {
      if (resp.status === 'success') {
        setTeamResult((prev) => {
          if (!prev) return prev
          const newScores = prev.scores.filter((score) => score.id !== id)

          return {
            ...prev,
            scores: newScores,
            totalScore: newScores.reduce((sum, score) => sum + score.score, 0),
            reviewCount: newScores.length,
          }
        })
      }
    })
  }

  return (
    <TopNavigationLayoutPageContent type='defaultWithBackButton'>
      <div className='flex-space-between'>
        <div className='inline-flex-gap' style={{ marginBottom: '1rem' }}>
          <h2 className='text--heading-h4' style={{ flexShrink: 0 }}>
            Защита
          </h2>
        </div>
      </div>

      <ProtectionInfoCard teamResult={teamResult} onDeleteReview={handleDeleteReview} />

      <div className='flex-space-between' style={{ marginTop: '1rem' }}>
        <div className='inline-flex-gap'>
          <h2 className='text--heading-h4' style={{ flexShrink: 0 }}>
            Дополнительная информация
          </h2>
        </div>
      </div>

      <ProtectionsInfoOptional teamResult={teamResult} />
    </TopNavigationLayoutPageContent>
  )
}

export default ProtectionTeamPage
